import React, { type ReactElement } from 'react';
import { tariffBuyCustomTitle } from 'reactApp/appHelpers/featuresHelpers';
import { vigboTariffs } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import type { Product } from 'reactApp/types/Billing';
import styles from 'reactApp/ui/TariffBuy/TariffBuy.css';
import { getPeriodName } from 'reactApp/utils/Period';
import { formatPrice, getMonthProductPrice } from 'reactApp/utils/priceHelpers';

type BuyTitleType = ({
    product,
    title,
    subTitle,
    isMobile,
}: {
    product?: Product;
    title?: string;
    subTitle?: string;
    isMobile: boolean;
}) => string | ReactElement;

export const useBuyTitle: BuyTitleType = ({ product, title, subTitle, isMobile }) => {
    const { hasDiscount, discountPrice, discountPeriod, trialPeriod, isForceDiscountTrial, space, hasTrial, price, period } = product || {};

    const { title: titleFromQuery = null, action = null } = getQueryParams();

    if (action === 'request-payment' && tariffBuyCustomTitle?.hasOwnProperty(titleFromQuery)) {
        return tariffBuyCustomTitle[titleFromQuery];
    }

    if (product?.id && vigboTariffs.includes(product?.id)) {
        const trialPeriodName = product.hasTrial && product.trialPeriod && getPeriodName(product.trialPeriod, false, true);

        const vigboTitle = product?.hasTrial
            ? `Подписка для фотографов Mail Space и Vigbo на ${trialPeriodName} бесплатно`
            : 'Подписка для фотографов Mail Space и Vigbo';

        const vigboSubTitle = 'Единая подписка на два сервиса для работы фотографа';

        return (
            <>
                {vigboTitle}
                <span className={styles.subtitle}>{vigboSubTitle}</span>
            </>
        );
    }

    if (product?.isFamily && product.isOnlyFeatures) {
        return 'Подключить семейные функции';
    }

    if (title && subTitle) {
        return (
            <>
                {title}
                {Boolean(subTitle) && <span className={styles.subtitle}>{subTitle}</span>}
            </>
        );
    }

    if (title) {
        return title;
    }

    if (product && isMobile && space) {
        if (isForceDiscountTrial) {
            return <>Подписка Mail&nbsp;Space {space.value}</>;
        }

        const priceToDisplay = hasDiscount ? discountPrice : price;
        const periodToDisplay = hasDiscount && discountPeriod ? discountPeriod : period;

        const priceText = priceToDisplay ? ` за\u00A0${formatPrice(getMonthProductPrice(product))}\u00A0₽ в\u00A0месяц` : '';

        return hasTrial ? (
            `Введите данные карты для получения ${space.value}${trialPeriod ? ` на ${getPeriodName(trialPeriod, false, true)}` : ''}`
        ) : (
            <>
                Оплата тарифа
                <br />
                {space.value} на {getPeriodName(periodToDisplay || '', false, true)}
                {priceText}
                {Boolean(subTitle) && <span className={styles.subtitle}>{subTitle}</span>}
            </>
        );
    }

    // пока убрали эту часть, тк хук используется только для тача
    // if (userTotalSpace && space) {
    //     const newSpace = bytesToNDigits(userTotalSpace.original + space.original, 3).value;
    //     return (
    //         <>
    //             Увеличение объёма до {newSpace}
    //             {Boolean(subTitle) && <span className={styles.subtitle}>{subTitle}</span>}
    //         </>
    //     );
    // }

    return 'Подписка на Облако';
};
